import React from 'react';

import K from '../k';

import NavMenu from './nav-menu';
import Icon from './icon';

const AppHeader = ({items = [], links, logo, style, ...rest}) => {
  const shouldRenderNavMenu = links?.length > 0;

  const styles = {
    header: {
      position: 'relative',
      display: 'flex',
      height: '70px',
      maxHeight: '70px',
      alignItems: 'center',
      padding: '12px 25px', //TODO confirm this padding is correct according to the mockup
      backgroundColor: K.colors.accent,
      ...K.fonts.su,
      ...style,
    },
    itemsGroup: {
      position: 'relative',
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: K.spacing,
      color: K.colors.base,
      overflow: 'hidden',
    },
    menu: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 20,
      height: 14
    },
    logo: {
      width: '2rem',
      height: '2rem',
    }
  };

  return (
    <div style={styles.header} {...rest}>
      {logo && <Icon style={styles.logo} src={logo} />}
      <div style={styles.itemsGroup}>{items}</div>
      {shouldRenderNavMenu && <NavMenu {...{links}} style={styles.menu}/>}
    </div>
  );
};

export default AppHeader;